// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"intro_wrapper__ZVnO_","text":"intro_text__cOul0"};